import React from 'react';
import Container from '@material-ui/core/Container';
import Resource from "../../Components/Resource";
import {withStyles} from "@material-ui/core";
import axios from "axios";
import config from "../../config/config";
import {bodyGet} from "../../utils/utils";

const styles = theme => ({
  texAlign: {
    'text-align': 'center',
    'margin-top': '15px'
  }
});
class Document extends React.Component {

  constructor(props) {
    super(props);
    this.state = { resources: defaultResources, documentId: props.match.params.id};
    this.getDocuments();
  };

  getDocuments(){
    console.log(this.state.documentId)
    return axios.post(config.apiUrl, bodyGet("OPERACION_GET_DOCUMENT", {documentId: this.state.documentId}))
        .then(res => {
          console.log(res);
          this.setState({resources:res.data.recursos})
          return res;
        })
        .catch(err => {
          console.log('Error:', err);
          this.setState({resources:defaultResources})

          return null;
        })
  }

  render() {

    return (
        <Container maxWidth="md" className={this.props.classes.texAlign}>
          {
            this.state.resources.map((resource) =>
                <Resource
                    type={resource.type}
                    content={resource.content}
                    url={resource.url}
                    graphType={resource.chart_type}
                    app={this.props.app}
                />
            )
          }

        </Container>

    );
  }

}


const defaultResources = [
  // {type: 'title', content: 'Título 1'},
  // {type: 'subtitle', content: 'Subtitle 1'},
  // {type: 'string', content: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.'},
  // {type: 'image', content:'https://vignette.wikia.nocookie.net/rick-y-morty-espanol/images/7/71/Rick_S%C3%A1nchez.png/revision/latest?cb=20170327172715&path-prefix=es'},
  // // {type: 'sound', content: 'audio.mp3'},
  // {type: 'video', content: 'A3VpSHqyA-I'},
  // {type: 'internalLink', content: 'Pulse aquí', url: '/menu'},
  // {type: 'externalLink', content: 'Pulsar', url: 'http://www.google.com'}
];


export default withStyles(styles)(Document);
